// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selected-status[data-v-5cb80766] {\n  font-size: 16px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
